import { Box, Fade, Tooltip, Typography } from '@mui/material'
import CustomChip from '../../../../../shared/components/CustomChip'
import VisibilityIcon from '../../../../../shared/components/icons/VisibilityIcon'

interface SlidersTitleCellProps {
  params: any
}

const SlidersTitleCell = ({ params }: SlidersTitleCellProps) => {
  const getStatusChip = (status: number) => {
    switch (status) {
      case 0:
        return <CustomChip size="small" color={'primary'} />
      case 1:
        return <CustomChip size="small" color={'secondary'} />
      case 2:
        return <CustomChip size="small" color={'grey'} />
      default:
        return <CustomChip size="small" color={'grey'} />
    }
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {getStatusChip(params.row.status)}
      <Tooltip placement="bottom-start" TransitionComponent={Fade} TransitionProps={{ timeout: 400 }} title={params.row.title}>
        <Typography
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            maxWidth: 300,
            fontWeight: 300,
            '@media (max-width: 600px)': {
              maxWidth: 150
            }
          }}
        >
          {params.row.title}
        </Typography>
      </Tooltip>
      <VisibilityIcon id={params.row.visibility} />
    </Box>
  )
}

export default SlidersTitleCell
